export const PUBLIC_ROUTES = [
  '/app/login',
  '/feedback-collect',
  '/visitor-registration',
  '/visitor-pass',
  '/service-desk',
  '/survey-collect',
  '/forgot-password',
  '/reset-password',
]
  
export const isPwaEnabled = path => {
  return !PUBLIC_ROUTES.some(route => path.startsWith(route))
}
  